(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["corporate-enquiry-form"] && !Shopify.designMode) return;
  try {
    
(() => {
  function setupEnquiryForms() {
    document.querySelectorAll('[data-ott-enquiry]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const form = root.querySelector('form');
      if (!form) return;
      const query = new URLSearchParams(window.location.search);
      const source = form.querySelector('[data-ott-enquiry-source]');
      if (source) source.value = ['utm_source','utm_medium','utm_campaign','utm_content'].filter(key => query.has(key)).map(key => key + '=' + query.get(key).slice(0,120)).join('; ');
      const success = form.querySelector('[data-ott-enquiry-success]');
      const pendingKey = 'ott_enquiry_pending_' + form.id;
      if (success) {
        success.focus();
        if (root.dataset.analyticsEnabled === 'true') {
          let pending = null;
          try { pending = sessionStorage.getItem(pendingKey); sessionStorage.removeItem(pendingKey); } catch (error) {}
          if (pending && Date.now() - Number(pending) < 1800000 && window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({event:'corporate_enquiry_success',form_id:form.id});
          }
        }
      } else if (root.dataset.analyticsEnabled === 'true') {
        form.addEventListener('submit', () => {
          if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()) {
            try { sessionStorage.setItem(pendingKey,String(Date.now())); } catch (error) {}
          }
        });
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',setupEnquiryForms); else setupEnquiryForms();
  document.addEventListener('shopify:section:load',setupEnquiryForms);
})();

  } catch(e) { console.error(e); }
})();
})();
